
<nz-modal
	[(nzVisible)]="deleteModal"
	(nzOnCancel)="deleteModal = false"
	(nzOnOk)="onDelete()"
	[nzTitle]="'common_deletion' | translate"
	[nzContent]="'common_delete-one' | translate"
	[nzOkLoading]="deleting"
></nz-modal>
<form nz-form
      class="gallery-form w-100"
      *ngIf="form"
      [formGroup]="form"
      (ngSubmit)="onSubmit()"
      [nzAutoTips]="explainErrorsService.autoTips">
    <nz-affix>
        <div class="py-4 border-bottom bg-white">
            <div class="container">
                <div class="row">
                    <div class="col-12 d-flex align-items-center justify-content-between">
            			<!-- Title -->
            			<div>
            				<h1 class="mb-0">
            					<span *ngIf="gallery.isNew()">{{ 'gallery_create-form-title' | translate }}</span>
            					<span *ngIf="!gallery.isNew()">{{ gallery.getLabel() }}</span>
            				</h1>
            				<small *ngIf="!gallery.isNew()" class="text-black-50">{{ 'common_id' | translate: { id : gallery.getId() } }}</small>
            			</div>
            			<!-- /Title -->
            			
            			<!-- Actions -->
            			<div>
            				<button
            					nz-button
            					[disabled]="form.invalid"
            					[nzLoading]="saving"
            					nzType="primary"
                                *appRestrictedByScope="{
                                    model: 'gallery',
                                    action: 'update'
                                }"
            				>
            					{{ 'common_save' | translate }}
            				</button>
                            <ng-container *appRestrictedByScope="{
                                model: 'gallery',
                                action: 'delete'
                            }">
                                <button
                                    *ngIf="!gallery.isNew() && deletable"
                                    class="ml-4"
                                    nz-button
                                    nzShape="circle"
                                    [title]="'common_delete' | translate"
                                    [nzLoading]="deleting"
                                    (click)="deleteModal = true"
                                    type="button"
                                >
                                    <i nz-icon nzType="delete"></i>
                                </button>
                            </ng-container>
            			</div>
            			<!-- /Actions -->
            		</div>
            	</div>
            </div>
        </div>
    </nz-affix>
    <div class="container">
    <nz-card class="round-border my-5">
    <div *ngIf="loading" class="row">
        <div class="col-12">
            <nz-skeleton class="no-header" [nzActive]="true"></nz-skeleton>
        </div>
    </div>
    <div *ngIf="!loading">
        <div class="row" *ngIf="!readOnly">
            <div class="col-12 col-md-6">
                <!-- Name -->

                
                <nz-form-item>
                    <h4>{{ 'gallery_name' | translate }}</h4>
                    <nz-form-control>

             
                        <input nz-input
                               class="w-100"
                               type="text"
                               [placeholder]="'common_value-string' | translate"
                               formControlName="name">
                    </nz-form-control>
                </nz-form-item>
                <!-- /Name -->
            </div>
            <div class="col-12 col-md-6">
                <!-- Images -->

                
                <nz-form-item>
                    <h4>{{ 'gallery_images' | translate }}</h4>
                    <nz-form-control [nzValidateStatus]="form.get('images')">

             
                        <hpf-image-select
                            [controlName]="'images'"
                            [formGroup]="form"
                            [quickFormEnabled]="quickFormEnabled"
                            [(model)]="gallery.props.images"
                            [multiple]="true"
                            [filterEnabled]="true"
                            [placeholder]="'image_common_search-placeholder' | translate"
                            [emptyLabel]="'common_empty' | translate">
                        </hpf-image-select>
                    </nz-form-control>
                </nz-form-item>
                <!-- /Images -->
            </div>
            <div class="col-12 col-md-6">
                <!-- Description -->

                <h4>{{ 'gallery_description' | translate }}</h4>
               	<app-language-tab [name]="'description'" [model]="gallery"></app-language-tab>
               	</div>

        </div>

        <nz-divider *ngIf="!gallery.isNew() && !readOnly"></nz-divider>
        <div *ngIf="!gallery.isNew()" class="row">
            <div class="col-12 col-md-6" >
                <!-- _Id -->
                <div class="mb-4">
                    <h4>{{ 'gallery_-id' | translate }}</h4>
                    <div>{{ gallery.props._id }}</div>
                </div>
                <!-- /_Id -->
            </div>
            <div class="col-12 col-md-6" >
                <!-- Created At -->
                <div class="mb-4">
                    <h4>{{ 'gallery_created-at' | translate }}</h4>
                    <div>{{ gallery.props.created_at | date:'medium' }}</div>
                </div>
                <!-- /Created At -->
            </div>
            <div class="col-12 col-md-6" *ngIf="readOnly">
                <!-- Name -->
                <div class="mb-4">
                    <h4>{{ 'gallery_name' | translate }}</h4>
                    <div>{{ gallery.props.name }}</div>
                </div>
                <!-- /Name -->
            </div>
            <div class="col-12 col-md-6" *ngIf="readOnly">
                <!-- Images -->
                <div class="mb-4">
                    <h4>{{ 'gallery_images' | translate }}</h4>
                    <div *ngIf="gallery.imagesExists()">
                        <div *ngFor="let item of gallery.props.images">
                            <a class="mr-2" [routerLink]="['/image', item.getId()]">
                                {{ item.getLabel() }}
                            </a>
                        </div>
                    </div>
                </div>
                <!-- /Images -->
            </div>
            <div class="col-12 col-md-6" *ngIf="readOnly">
                <!-- Description -->
                <div class="mb-4">
                    <h4>{{ 'gallery_description' | translate }}</h4>
                    <div *ngIf="gallery.descriptionExists()">
                        <div *ngFor="let item of gallery.props.description">
                            <a class="mr-2" [routerLink]="['/text-translated', item.getId()]">
                                {{ item.getLabel() }}
                            </a>
                        </div>
                    </div>
                </div>
                <!-- /Description -->
            </div>
        </div>
    </div>
    </nz-card>
    </div>
</form>
